
























import {
    defineComponent,
    computed,
} from '@vue/composition-api';
import AboutSuperbet from '@modules/layout/footer/components/AboutSuperbet.vue';
import LegalSection from '@modules/layout/footer/components/LegalSection.vue';
import { useThemedLogo } from '@superbet-group/web.lib.ui-components';

export default defineComponent({
    setup() {
        const logoUrl = useThemedLogo(computed(() => 'brand-supersocial'));

        return {
            logoUrl,
        };
    },
    components: {
        LegalSection,
        AboutSuperbet,
    },
});
